module.exports = __webpack_public_path__ + "../resources/images/contact-card-icon-email-f35e0213850bb7695df2bf637e3d5c8f.png";